import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { Features } from '@src/core/features';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionContext } from '../authentication';
import { useProjectContext } from '../switch-project';

const ExportMenu: FC<MenuItemStateProps> = ({ isMini }) => {
  const { allowedFeature } = useProjectContext();
  const { isAdmin, isManager } = useSessionContext();
  const { COLORS } = useTheme();
  const navigate = useNavigate();

  if (!allowedFeature(Features.EXPORT) || (!isAdmin && !isManager)) {
    return <></>;
  }

  const handleClick = () => {
    navigate('/export', { replace: true });
  };

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: 'Exportar Dados',
        icon: <FileDownloadIcon sx={{ color: COLORS.primary.main }} />,
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={handleClick}
    />
  );
};

export { ExportMenu };
